<template class="teste">
  <div class="box" id="cardContainer">
    <b class="titleGraph">Gênero</b>
    <apexchart
      type="donut"
      :options="chartOptions"
      :series="getSeries"
      height="100%"
      width="100%"
    ></apexchart>
  </div>
</template>
<script>
export default {
  name: "apexchartPie",
  props: {
    data: {
      type: Object
    },
    loading: {
      type: Boolean
    },
    openModal: {
      type: Boolean
    }
  },
  data() {
    return {
      series: this.data.data,
      chartOptions: {
        labels: this.data.labels,
        chart: {
          toolbar: {
            show: true
          }
        },

        plotOptions: {
          pie: {
            donut: {
              size: "40%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "20px",
                  fontFamily: "sans-Serif"
                },
                volue: {
                  show: true
                }
              }
            }
          }
        },
        dataLabels: {
          style: {
            fontFamily: "sans-serif",
            fontSize: "1rem"
          }
        },
        legend: {
          position: "top"
        },
        colors: ["#F56618", "#eae123", "#07b701"]
      }
    };
  },
  computed: {
    getSeries() {
      let series = this.data.data;
      return series;
    }
  },
};
</script>
<style lang="scss">
.modalChart {
  display: flex;

  flex-direction: column;
}
.titleGraph {
  color: #424242;
  font-size: 22px;
  font-family: sans-serif;
}
#cardContainer {
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ApexChartPieGender.vue